import { BrowserModule } from '@angular/platform-browser';
import { APP_INITIALIZER, LOCALE_ID, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { JwtModule } from '@auth0/angular-jwt';
import { registerLocaleData } from '@angular/common';
import ptBr from '@angular/common/locales/pt';

import { AppComponent } from './app.component';
import { LoginComponent } from './master/components/login/login.component';
import { HttpClientInterceptor } from './interceptor/httpInterceptor';
import { ErrorInterceptor } from './interceptor/errorInterceptor';
import { AuthorizationCheck } from './auth/authorizationCheck';
import { AuthenticationService } from './services/authentication.service';
import { HomeComponent } from './Views/home/home.component';
import { MasterPageComponent } from './master/masterpage.component';
import { AppConfig } from './app.config';
import { DynamicMenuService } from './services/dynamic-menu.service';
import { BusinessProcessService } from './services/business-process.service';
import { MasterModule } from './master/master.module';
import { AdminModule } from './Views/Admin/admin.module';
import { RuntimeModule } from './Views/Runtime/runtime.module';
import { GenericModalComponent } from './generic-modal/generic-modal.component';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { EditFieldsService } from './services/edit-fields.service';
import { HumanInteractionModule } from './Views/HumanInteraction/human-interaction.module';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ConfigurationModule } from './Views/Configuration/configuration.module';
import { BatchModule } from './Views/Batch/batch.module';
import { AccountModule } from './Views/Account/account.module';
import { NotFoundPageComponent } from './master/components/not-found-page/not-found-page.component';

export function tokenGetter() {
  return localStorage.getItem('TokenInfo');
}

registerLocaleData(ptBr);


@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    HomeComponent,
    GenericModalComponent,
    NotFoundPageComponent
  ],
  entryComponents: [ GenericModalComponent, NotFoundPageComponent ],
  imports: [
    BrowserModule.withServerTransition({ appId: 'ng-cli-universal' }),
    HttpClientModule,
    MasterModule,
    AdminModule,
    RuntimeModule,
    HumanInteractionModule,
    ConfigurationModule,
    BatchModule,
    BsDatepickerModule.forRoot(),
    BrowserAnimationsModule,
    AccountModule,
    JwtModule.forRoot({
      config: {
        tokenGetter: tokenGetter,
        allowedDomains: ['localhost:5000'],
        disallowedRoutes: []
      }
    }),
    FormsModule,
    ReactiveFormsModule,
    RouterModule.forRoot([
      { path: 'home', component: MasterPageComponent, children: [{ outlet: 'master', path: '', component: HomeComponent }]
        , canActivate: [AuthorizationCheck], runGuardsAndResolvers: 'always'
      },
      { path: '', redirectTo: '/home', pathMatch: 'full' },
      { path: 'login', component: LoginComponent },
      { path: '**', component: NotFoundPageComponent }
    ], {onSameUrlNavigation: 'reload'}
    )
  ],
  providers: [
    AuthorizationCheck, AuthenticationService, AppConfig, DynamicMenuService, BusinessProcessService, EditFieldsService, BsModalRef,
    { provide: APP_INITIALIZER, useFactory: (config: AppConfig) => () => config.loadAppConfig(), deps: [AppConfig], multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: HttpClientInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    { provide: LOCALE_ID, useValue: window.navigator.language }
    ],
  bootstrap: [AppComponent]
})
export class AppModule { }
